//import Rating from "../../component/sidebar/rating";

const title = "Stage Confidence & Microphone Handling for Singers";
const desc = "Master live stage performance, boost confidence, improve stage presence, and learn professional microphone techniques.";
const author = "Michael Lee";
const reviewCount = "08 reviews";
const videoLink = "https://www.youtube-nocookie.com/embed/jP649ZHA8Tg";

const categoryList = [
    {
        link: '#',
        text: 'Performance Training',
        className: 'course-cate',
    },
    {
        link: '#',
        text: '12 Lessons',
        className: 'course-offer',
    },
];

const StagePerformance = () => {
    return (
        <div className="pageheader-section style-2">
            <div className="container">
                <div className="row justify-content-center justify-content-lg-between align-items-center flex-row-reverse">
                    <div className="col-lg-7 col-12">
                        <div className="pageheader-thumb">
                            <img src="assets/images/art/StagePerformance.png" alt="Stage Performance" className="w-100" />
                            <a href={videoLink} className="video-button popup" target="_blank" rel="noopener noreferrer">
                                <i className="icofont-ui-play"></i>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-5 col-12">
                        <div className="pageheader-content">
                            <div className="course-category">
                                {categoryList.map((val, i) => (
                                    <a href={val.link} className={val.className} key={i}>{val.text}</a>
                                ))}
                            </div>
                            <h2 className="phs-title">{title}</h2>
                            <p className="phs-desc">{desc}</p>
                            <div className="phs-thumb">
                                <img src="assets/images/course/author/04.jpg" alt={author} />
                                <span>{author}</span>
                                <div className="course-reiew">
                                    {/* <Rating /> */}
                                    <span className="ratting-count">{reviewCount}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StagePerformance;
